/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_Tab_GeneralInputs */

const en_ui_settings_tab_general = /** @type {(inputs: Ui_Settings_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const de_ui_settings_tab_general = /** @type {(inputs: Ui_Settings_Tab_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Ui_Settings_Tab_GeneralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_tab_general = /** @type {((inputs?: Ui_Settings_Tab_GeneralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_Tab_GeneralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_tab_general(inputs)
	return de_ui_settings_tab_general(inputs)
});